import { PRODUCT_CONDITIONS } from "@/lib/productCondition";

interface ConditionSelectorProps {
  value: number;
  onChange: (value: number) => void;
}

export default function ConditionSelector({ value, onChange }: ConditionSelectorProps) {
  return (
    <div>
      <label className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-0.5 block">
        Stanje oštećenja
      </label>
      <p className="text-[11px] text-muted-foreground mb-2 leading-relaxed">
        Nova, brend odjeća s oštećenjem: 1 = najmanje, 5 = najteže. Kupac vidi ovo kao oznaku na
        artiklu.
      </p>
      <div className="flex gap-1.5 sm:gap-2">
        {PRODUCT_CONDITIONS.map((c) => (
          <button
            key={c.value}
            type="button"
            title={c.description}
            onClick={() => onChange(c.value)}
            className={`flex-1 min-w-0 py-2.5 sm:py-3 px-0.5 rounded-xl border-2 transition-all active:scale-[0.96] ${
              value === c.value
                ? "border-foreground bg-foreground text-white shadow-lg shadow-foreground/20"
                : "border-border bg-white hover:border-neutral-300"
            }`}
          >
            <div
              className={`size-2.5 rounded-full mx-auto mb-1 sm:mb-1.5 ${c.dotClass} ${
                value === c.value ? "ring-2 ring-white" : ""
              }`}
            />
            <div
              className={`text-[9px] sm:text-[10px] font-semibold leading-tight ${
                value === c.value ? "text-white" : "text-neutral-500"
              }`}
            >
              <span className="block text-[11px] sm:text-xs font-bold tabular-nums">
                {c.value}
              </span>
              <span className="block mt-0.5 line-clamp-2 sm:line-clamp-none">
                {c.shortName}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
